module.exports = __webpack_public_path__ + "img/safari_2.fe25d255.png";